export const VideoProgress = {
  bindings: {
    progress: '<',
  },

  template: `
    <div class="video-progress progress">
      <div
        class="progress-bar bg-danger"
        role="progressbar"
        ng-style="{ width: $ctrl.progress + '%'}"
        aria-valuenow="{{ $ctrl.progress }}"
        aria-valuemin="0"
        aria-valuemax="100">
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Video/VideoProgress.js